import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { CommonCampaignsService } from '../../../../../app.retailer.common/modules/services/commonCampaigns.service';
import { Campaign } from '../../../core';
import { IRetailerRootScope } from '../../../core/models';
import { IAudienceOffer, ICampaign, ICampaignVideo, ICampaignVideoRetailerMessage } from '../../models';
import { CampaignsService } from '../../services/campaigns.service';

export class MarketingViewCampaignController {
    public static $inject = ['$scope', '$state', 'campaignsService', 'commonCampaignsService', 'notificationService', '$rootScope', '$timeout', '$translate'];

    public campaign: ICampaign = null;
    public videos: ICampaignVideo[] = [];
    public isRetailing = true;
    public customScroll = this.campaignsService.customScrollView;
    public isArchived = false;
    public currencySign: string;
    public audienceOffer: IAudienceOffer;
    private shopID: number = null;

    constructor(
        private $scope: ng.IScope,
        private $state: StateService,
        private campaignsService: CampaignsService,
        private commonCampaignsService: CommonCampaignsService,
        private notificationService: NotificationService,
        private $rootScope: IRetailerRootScope,
        private $timeout: ng.ITimeoutService,
        private $translate: angular.translate.ITranslateService) {

        $scope.$on('$includeContentRequested', (event, url: string) => {
            notificationService.showWaitingMessage();
        });

        $scope.$on('$includeContentLoaded', (event, url: string) => {
            notificationService.clearAll();
        });

        $scope.$on('$includeContentError', (event, url: string) => {
            notificationService.showErrorMessage();
        });

        $rootScope.$on('CampaignVideoProcessingFinish', (event, data: ICampaignVideoRetailerMessage) => this.onUpdateCampaignVideoProcessing(event, data));

        $rootScope.$on('CampaignVideoProcessingError', (event, data: ICampaignVideoRetailerMessage) => this.onUpdateCampaignVideoProcessing(event, data));
    }

    public copyCampaign = () => {
        this.campaignsService.setEditableCampaign(this.campaign, true);
        this.$state.go('app.marketing-campaigns.copy', { id: this.shopID });
    }

    public editCampaign = () => {
        this.campaignsService.setEditableCampaign(this.campaign, false);
        this.$state.go('app.marketing-campaigns.edit', { id: this.shopID });
    }

    public $onInit = async () => {
        this.shopID = this.$state.params.id;
        await this.refreshCampaign();
        const promise  = this.campaignsService.getCountry();
        promise.then((result) => {
                this.currencySign = result.CurrencySign;
            });
        }

    private refreshCampaign = async () => {
        try {
            this.notificationService.showWaitingMessage();
            this.campaign = await this.campaignsService.getCampaign(this.shopID);
            this.campaign.currencySign = this.currencySign;
            this.isArchived = this.campaign.entityStatus === Campaign.EntityStatusEnum.NUMBER_5;
            if (this.campaign.video) {
                this.videos = [];
                await this.$timeout(0);
                this.videos.push(this.campaign.video);

            }
            const audienceResource = await this.campaignsService.getAudience();
            this.audienceOffer = this.campaignsService.getAudienceModel( audienceResource, this.campaign.offerAudience);

            this.campaignsService.resizeFontWithTimeOut();
            this.$scope.$emit('campaignsPanelChanged');
            this.customScroll();
            this.notificationService.clearAll();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
    }

    private async onUpdateCampaignVideoProcessing(event: ng.IAngularEvent, data: ICampaignVideoRetailerMessage) {

        if (!data.CampaignID) {
            return;
        }

        if (data.CampaignID === this.shopID) {

            // if (event.name === 'CampaignVideoProcessingFinish') {
            //     this.notificationService.showSuccessMessage(this.$translate.instant('campaign_video_processed_successfully'));
            // } else if (event.name === 'CampaignVideoProcessingError') {
            //     this.notificationService.showErrorMessage(this.$translate.instant('campaign_video_processed_error'));
            // }

            await this.refreshCampaign();
        }
    }
}

angular
    .module('naut')
    .component('viewCampaign', {
        template: require('./viewCampaign.html'),
        controller: MarketingViewCampaignController,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/campaigns/components/viewCampaign/viewCampaign.component.ts